import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppointmentIcon from "../components/AppointmentIcon";
import { FaChevronDown } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { GetDoctors, PostApointMent, ValidateFollowUp } from "../utils/Api";
import { toast } from "react-toastify";
import {
  setBasicData,
  setConsultData,
  setTempData,
} from "../Redux/Actions/Actions";
import OfferCard from "../components/OfferCard";

export default function Doctor() {
  const navigate = useNavigate();
  const Const = useSelector((state) => state.Const);
  const Basic = useSelector((state) => state.Basic);
  const [data, setData] = useState([]);
  const [isOpen, setIsOpen] = useState(0);
  const [clinicId, setClinicId] = useState("");
  const [isPayement, setIsPayement] = useState(false);
  const [isNoSlots, setIsNoSlots] = useState(true);
  const iconSize = 24;
  const Dispatch = useDispatch();

  const selectedDate = useMemo(() => {
    return Const.finalDate;
  }, []);

  const [selctedSlot, setSelectedSlot] = useState({
    doctorId: "",
    slot: "",
    slotType: "",
    appointmentType: "",
    netFees: "",
    index: 0,
    doctorName: "",
  });

  useEffect(() => {
    if (Const != null && Basic?.id) {
      GetDoctors(
        Const.consultType,
        Const.finalDate,
        Const.selectedDoctor,
        Const.selectedSpeciality,
        Const.selectedAddress,
        "",
        Basic.id
      ).then((res) => {
        if (res.status == true) {
          setData(res.data);
          if (res.SlotCount == 0) {
            setIsNoSlots(true);
          } else {
            setIsNoSlots(false);
          }
        } else {
          setData([]);
        }
      });
    }
  }, [
    Const?.consultType,
    Const?.finalDate,
    Const?.selectedDoctor,
    Const?.selectedSpeciality,
    Const?.selectedAddress,
    Basic?.id,
  ]);

  const GetIn24 = (time) => {
    if (!time) return "";
    const formats = ["hh:mm A", "h:mm A", "h:mmA", "hh:mmA", "HH:mm", "H:mm"];
    const parsed = moment(time, formats, false);
    return parsed.isValid() ? parsed.format("HH:mm") : "";
  };

  const handleSlots = (slots) => {
    if (!Array.isArray(slots) || slots.length === 0) return [];
    // Return only the first three valid future slots, formatted to "hh:mm A"
    return slots.slice(0, 3).map((slot) => ({
      ...slot,
      slot: moment(GetIn24(slot.slot), "HH:mm").format("h:mmA"),
    }));
  };

  const handleAllSlots = (slots, clid, doctorName) => {
    // Group slots by time of day and render them
    return (() => {
      if (!Array.isArray(slots) || slots.length === 0) return null;

      // Helper to get slot in 24h format
      const get24 = (slot) => GetIn24(slot);

      // Helper to get slot in 12h format
      const get12 = (slot) => moment(GetIn24(slot), "HH:mm").format("h:mmA");

      // Grouping logic
      const groups = {
        Morning: [],
        Afternoon: [],
        Evening: [],
      };

      slots.forEach((slotObj) => {
        if (!slotObj || typeof slotObj.slot !== "string") return;
        const slot24 = get24(slotObj.slot);
        const hour = parseInt(slot24.split(":")[0], 10);

        if (hour >= 5 && hour < 12) {
          groups.Morning.push(slotObj);
        } else if (hour >= 12 && hour < 17) {
          groups.Afternoon.push(slotObj);
        } else if (hour >= 17 && hour < 22) {
          groups.Evening.push(slotObj);
        }
      });

      return (
        <div>
          {Object.entries(groups).map(([label, group]) =>
            group.length > 0 ? (
              <div key={label} className="mb-2">
                <p className="font-semibold mb-1">{label} slots</p>
                <div className="grid grid-cols-3 gap-4">
                  {group.map((slotObj, idx) => (
                    <div
                      key={idx}
                      className={`w-max px-5 py-2 rounded-md cursor-pointer ${
                        selctedSlot.doctorId === slotObj.doctorID &&
                        selctedSlot.slot === GetIn24(slotObj.slot)
                          ? "bg-primary text-white"
                          : "bg-white text-gray-700"
                      }`}
                      onClick={() => {
                        setSelectedSlot({
                          doctorId: slotObj.doctorID,
                          slot: get24(slotObj.slot),
                          slotType: slotObj.slotType,
                          appointmentType: slotObj.appointmenttype,
                          netFees: slotObj.netFees,
                          index: idx,
                          doctorName,
                        });
                        setClinicId(clid);
                      }}
                    >
                      <p>{get12(slotObj.slot)}</p>
                    </div>
                  ))}
                </div>
              </div>
            ) : null
          )}
        </div>
      );
    })();
  };

  const handleContinue = async () => {
    if (selctedSlot.doctorId === "") {
      toast.error("Please select a slot");
      return;
    }
    if (Const.consultType == "follow up") {
      let isAllClear = true;
      await ValidateFollowUp(Basic.id, selctedSlot.doctorId).then((res) => {
        if (res.status == false) {
          isAllClear = false;
          toast.error(res.message);
        }
      });
      if (!isAllClear) {
        return;
      }
    }

    const normalHeader = {
      "Content-Type": "application/json",
      device: "Android",
      Accept: "application/json",
      CorrelationId: 1234551516516565,
      AuthToken: Basic.authToken,
      userId: Basic.id,
    };
    let data = {
      guestId: Basic.id,
      consultType: Const.consultType,
      consultationDate: Const.finalDate,
      slot: selctedSlot.slot,
      FromTime: selctedSlot.slot,
      ToTime: selctedSlot.slot,
      languages: Const.languages,
      userType: Basic.type,
      DoctorId: selctedSlot.doctorId,
      clinic: clinicId,
      helpQuestion1: Basic.qs,
      AppointmentReqID: Basic.appReqId,
    };

    PostApointMent(normalHeader, data).then((r) =>
      r.json().then((d) => {
        if (d.status) {
          ;
          
          let tempBasic = Basic;
          tempBasic.appReqId = d.appReqId;
          tempBasic.netFees = selctedSlot.netFees;
          tempBasic.doctorId = selctedSlot.doctorId;
          tempBasic.apointmentType = Const.consultType;
          tempBasic.clinicId = clinicId;
          tempBasic.doctorName = selctedSlot.doctorName;
          // tempBasic.isMobile = Basic.isMobile
          console.log(tempBasic);
          

          let _const = Const;
          _const.doctorName = selctedSlot.doctorName;
          _const.slotToShow = selctedSlot.slot;
          Dispatch(setConsultData(_const));

          Dispatch(setBasicData(tempBasic));
          Dispatch(setTempData(d));
          setIsPayement(true);
        }
      })
    );
  };
  const HandlePayment = () => {
    navigate("/payement-page");
  };

  const handleDoctorProfileOpen = (id) => {
    let url = `https://dashboard.gleeohealth.com/Patient/DoctorProfile?id=${Basic.id}&doctorId=${id}`;
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.click();
    if (window.ReactNativeWebView != null) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "DOCTOR_PROFILE_OPEN",
          data: { url },
        })
      );
    }
  };

  return (
    <div className="container h-screen max-w-md mx-auto text-thtext">
      <div className="h-[91%] flex flex-col w-full overflow-auto p-8 scrollbar-invisible">
        {data.length == 0 || isNoSlots == true ? (
          <div className="w-full flex items-center justify-center h-full">
            <p className="text-gray-500">No doctors available for this date</p>
          </div>
        ) : (
          <div>
            {data.map((item, index) => (
              <>
                {item.Slots.length > 0 && (
                  <div
                    className="p-4 bg-gray-200 rounded-lg shadow-md mb-6"
                    key={index}
                  >
                    <div className="flex flex-wrap items-center justify-between">
                      <div>
                        <span className="text-sm">
                          {moment(selectedDate).format("DD MMM, YYYY")}
                        </span>
                      </div>
                      <div className="flex flex-wrap items-center justify-end space-x-1">
                        {item.Types.length > 0 &&
                          item.Types.map((type, idx) => (
                            <AppointmentIcon
                              key={idx}
                              type={type.appointmenttype}
                              iconSize={iconSize}
                            />
                          ))}
                      </div>
                    </div>
                    <div className="flex items-center justify-evenly mb-4 mt-2">
                      <div className="w-1/2 flex flex-col items-center">
                        <div className="w-32 h-32 bg-white rounded-full shadow-md flex items-center justify-center">
                          <img
                            src={
                              item.imagePath != ""
                                ? item.imagePath
                                : item.gender == "Male"
                                ? "./assets/male-doctor.png"
                                : "./assets/female-doctor.png"
                            }
                            className="rounded-full w-32 h-32 p-1"
                            width={100}
                            height={100}
                          />
                        </div>
                        <button
                          className="border border-primary  h-8 flex items-center justify-center text-primary font-bold py-1 px-2 rounded-full w-max mt-2 text-sm"
                          onClick={() => handleDoctorProfileOpen(item.doctorID)}
                        >
                          View Profile
                        </button>
                      </div>
                      <div className="w-1/2 ">
                        <h2 className="text-lg font-bold">{item.doctorName}</h2>
                        <p className="text-sm text-gray-600">
                          {item.speciality}
                        </p>
                        <p className="text-sm text-gray-600">
                          {item.experience} Yrs Exp
                        </p>
                        <p className="text-sm text-gray-600">
                          {item.qualification}
                        </p>
                        {item.Slots.length > 0 && (
                          <p className="text-sm text-gray-600">
                            Fees -{" "}
                            <span className="font-bold">
                              {item.Slots[0].appointmenttype}
                            </span>{" "}
                            Rs:
                            {item.Slots[0].netFees}
                          </p>
                        )}
                        <p className="text-sm text-gray-600 mt-4">
                          {item.clinicName}
                        </p>
                      </div>
                    </div>
                    <div
                      className={`transition-all duration-300 overflow-hidden flex space-x-2 ${
                        isOpen !== index + 1
                          ? "max-h-96 opacity-100 mt-2"
                          : "max-h-0 opacity-0"
                      }`}
                    >
                      {handleSlots(item.Slots).length > 0 ? (
                        <div className="flex items-center space-x-2">
                          {handleSlots(item.Slots).map((slot, index) => (
                            <div
                              className={`w-max px-5 py-2 rounded-md cursor-pointer ${
                                selctedSlot.doctorId === item.doctorID &&
                                selctedSlot.slot === GetIn24(slot.slot)
                                  ? "bg-primary text-white"
                                  : "bg-white text-gray-700"
                              }`}
                              key={index}
                              onClick={() => {
                                setSelectedSlot({
                                  doctorId: item.doctorID,
                                  slot: GetIn24(slot.slot),
                                  slotType: slot.slotType,
                                  appointmentType: slot.appointmenttype,
                                  netFees: slot.netFees,
                                  index: index,
                                  doctorName: item.doctorName,
                                });
                                setClinicId(item.clinicId);
                              }}
                            >
                              <p>{slot.slot}</p>
                            </div>
                          ))}
                          <div
                            className="w-max p-3 bg-white rounded-md cursor-pointer"
                            onClick={() =>
                              setIsOpen(isOpen === index + 1 ? 0 : index + 1)
                            }
                          >
                            <FaChevronDown
                              className={`w-4 h-4 transition-transform duration-300 ${
                                isOpen === index + 1 ? "rotate-180" : ""
                              }`}
                            />
                          </div>
                        </div>
                      ) : (
                        <p className="w-full text-center text-gray-500">
                          No available slots for this time
                        </p>
                      )}
                    </div>
                    <div
                      className={`transition-all duration-300 overflow-hidden ${
                        isOpen === index + 1
                          ? "max-h-96 opacity-100 mt-2"
                          : "max-h-0 opacity-0"
                      }`}
                      style={{
                        pointerEvents: isOpen === index + 1 ? "auto" : "none",
                      }}
                    >
                      <div className="p-2 rounded-md mt-4 bg-white">
                        <div
                          className="flex items-center justify-between cursor-pointer"
                          onClick={() =>
                            setIsOpen(isOpen === index + 1 ? 0 : index + 1)
                          }
                        >
                          <div className="text-gray-600">
                            <h1>{item.Slots.length} available slots</h1>
                          </div>
                          <div className="w-max p-3 bg-white rounded-md cursor-pointer">
                            <FaChevronDown
                              className={`w-4 h-4 transition-transform duration-300 ${
                                isOpen === index + 1 ? "rotate-180" : ""
                              }`}
                            />
                          </div>
                        </div>
                        <div className="mt-2 max-h-96 overflow-auto">
                          {handleAllSlots(
                            item.Slots,
                            item.clinicId,
                            item.doctorName
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ))}
            <OfferCard />
          </div>
        )}
      </div>
      <div className="flex bg-white p-4">
        <button
          className=" bg-primary h-12 flex items-center justify-center text-white font-bold py-2 px-4 rounded-full w-full"
          onClick={() => navigate(-1)}
        >
          Back
        </button>
        {data.length > 0 && (
          <>
            <button
              className="bg-primary h-12 flex items-center justify-center text-white font-bold py-2 px-4 rounded-full w-full ml-2"
              style={{ display: isPayement ? "none" : "flex" }}
              onClick={handleContinue}
            >
              Confirm
            </button>
            <button
              className="bg-primary h-12 flex items-center justify-center text-white font-bold py-2 px-4 rounded-full w-full ml-2"
              style={{ display: !isPayement ? "none" : "flex" }}
              onClick={HandlePayment}
            >
              Make Payment
            </button>
          </>
        )}
      </div>
    </div>
  );
}
